import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { mediaUrl } from "@/lib/config/app";
import Link from "next/link";
import PureHtml from "@/components/custom/PureHtml";
export default function BrowseRange(t0) {
  const $ = _c(12);
  const {
    sbcats
  } = t0;
  const t1 = sbcats?.heading || "Browse Our Popular Ranges";
  let t2;
  if ($[0] !== t1) {
    t2 = <h2 className="text-xl lg:text-2xl">{t1}</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = sbcats?.subtext;
  let t4;
  if ($[2] !== t3) {
    t4 = <PureHtml html={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== sbcats?.scats) {
    t5 = sbcats?.scats.length > 0 && sbcats?.scats?.slice(0, 8).map(_temp);
    $[4] = sbcats?.scats;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <div className="grid grid-cols-2 lg:grid-cols-4 gap-1 lg:gap-3 text-center mt-2">{t5}</div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t6) {
    t7 = <section className="browse-range py-2 lg:py-4"><div className="max-w-7xl mx-auto px-2">{t2}{t4}{t6}</div></section>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function _temp(sbcat, sdx) {
  const imageAlt = sbcat?.image_alt || sbcat?.cat_name || "Collections";
  return <div className="brange" key={sdx} title={sbcat?.cat_name}><Link href={`/collections/${sbcat?.cat_slug}`}><div className="p-2 lg:p-4 rounded bg-primary text-white shadow"><Image src={`${mediaUrl}${sbcat?.image_url || "noimage.png"}`} className="rounded-full mx-auto" width={64} height={64} alt={imageAlt} /><div className="font-heading mt-2 lg:text-xl">{sbcat?.cat_name || "Collection"}</div></div></Link></div>;
}